export default {
  path: '/users',
  name: 'Users',
  component: () => import(/* webpackChunkName: "base" */ '../views/UsersView.vue'),
  meta: {
    exclude: false,
    requiresAuth: true
  }
}
